/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from "react";
import { jsx } from "theme-ui";
import { graphql } from "gatsby";
import { Container } from "theme-ui";

import Layout from "../components/Layout";

import PageSection from "../components/PageSection";
import BlogPost from "../components/BlogPost";
import BlogPostPagination from "../components/BlogPostPagination";
import BlogPostCta from "../components/BlogPostCta";
import Articles from "../components/Articles";

// pageContext is passed in gatsby-node createPages
const BlogPostPage = ({ data, pageContext }) => {
  const post = data.markdownRemark;
  const { id, fileAbsolutePath, frontmatter } = post;
  const { title: blogTitle, author, date, image, alt } = frontmatter;
  const { previous, next } = pageContext;
  const isReleaseNote = fileAbsolutePath.includes("/release-notes/");

  return (
    <Layout title={blogTitle} description={post.excerpt} image={image.publicURL}>
      <PageSection>
        <Container sx={{maxWidth: 600}}>
          <section sx={{mb: 7}}>
            <BlogPost
              image={image}
              alt={alt || "Illustrative image for the blog post"}
              title={blogTitle}
              author={author || "Erik Jälevik"}
              date={date}
              content={post.html}
            />
          </section>
          <BlogPostPagination previous={previous} next={next} />
        </Container>
      </PageSection>
      {!isReleaseNote && (<>
        <BlogPostCta />
        <Articles title="More from the blog" exclude={id} />
      </>)}
    </Layout>
  );
};

export default BlogPostPage;

export const pageQuery = graphql`
  query BlogQuery($slug: String!) {
    markdownRemark(fields: {slug: {eq: $slug}}) {
      id
      excerpt(format: PLAIN)
      html
      fileAbsolutePath
      frontmatter {
        title
        date(formatString: "D MMMM YYYY")
        image {
          childImageSharp {
            gatsbyImageData(quality: 90, width: 600, layout: CONSTRAINED)
          }
          publicURL
        }
        alt
      }
    }
  }
`;
